import {
    makeApiGetRequest,
    makeApiPatchRequest,
} from '../api/apiActions';

class LCServiceClient {
    static NAME = 'lc';

    static LC_CONTENT_URL = '/lc_content_api/passages';

    static LC_RESULTS_URL = '/lc_results_api';

    static RESULT_OPERATION = {
        ADD_COMPREHENSION_RESPONSE: 'add_comprehension_response',
    };

    /**
     * Construct and return the URL API endpoint for a list of results
     */
    static constructResultListEndpoint({
        studentId, grade, period, schoolYear
    } = {}) {
        let endpoint = `${LCServiceClient.LC_RESULTS_URL}/results`;
        const params = [];
        if (studentId) {
            params.push(`student_uids=${studentId}`);
        }
        if (grade) {
            params.push(`grade_level=${grade}`);
        }
        if (period) {
            params.push(`period=${period}`);
        }
        if (schoolYear) {
            params.push(`school_year=${schoolYear}`);
        }
        if (params.length > 0) {
            endpoint += `?${params.join('&')}`;
        }
        return endpoint;
    }

    /**
     * Construct and return the URL API endpoint for a given resultId
     * @param {str} resultId
     */
    static constructResultEndpoint(resultId) {
        return `${LCServiceClient.LC_RESULTS_URL}/results/${resultId}`;
    }

    /**
     * Construct and return the URL API endpoint for passage entity
     * @param {str} id - passage id
     */
    static constructPassageEndpoint({ id }) {
        let endpoint = `${LCServiceClient.LC_CONTENT_URL}`;
        if (id) {
            endpoint += `/${id}`;
            return endpoint;
        }
        return endpoint;
    }

    /**
     * Sends PATCH request for result endpoint and returns a response
     * @param {str} resultId - id of the result to PATCH
     * @param {str} operation - PATCH operation, one of LCServiceClient.RESULT_OPERATION
     * @param {object} data - PATCH data specific for provided operation
     * @param {object} studentUid - Student UID of the user
     * @returns {JSON} server response
     */
    static patchResult = (resultId, operation, data, studentUid) => dispatch => {
        const patchData = {
            operation,
            data,
            student_uid: studentUid,
        };
        const endpoint = LCServiceClient.constructResultEndpoint(resultId);
        return dispatch(makeApiPatchRequest(endpoint, patchData));
    };

    /**
     * Sends GET request to results endpoint with provided parameters
     * @param {str} studentId - id of the student to get results for
     * @param {str} grade - (optional) student's grade (KG | 01)
     * @param {str} period - (optional) BOY | MOY | EOY
     * @param {number} schoolYear - assessment school year
     * @returns {JSON} server response
     */
    static getResults = (studentId, grade, period, schoolYear) => dispatch => {
        const config = {
            studentId,
            grade,
            period,
            schoolYear,
        };
        const endpoint = LCServiceClient.constructResultListEndpoint(config);
        return dispatch(makeApiGetRequest(endpoint));
    };
}

export default LCServiceClient;
